module.exports = __webpack_public_path__ + "static/media/comment-message.49fd63b1.svg";